import { Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import Button from "../Common/Button";

const ContentSuccessModal = ({ isOpen, onClose, onView }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/60 px-4 py-6 sm:items-center">
            <div className="relative w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
                <button
                    type="button"
                    onClick={onClose}
                    className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-primary shadow focus:outline-none"
                    aria-label={t("COMMON_CLOSE")}
                >
                    <X className="h-5 w-5" />
                </button>
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary">
                    <Check className="h-6 w-6 text-white" />
                </div>
                <h2 className="mt-6 text-lg font-semibold text-slate-900">{t("MY_CONTENT_SUCCESS_TITLE")}</h2>
                <p className="mt-2 text-sm text-slate-500">
                    {t("MY_CONTENT_SUCCESS_SUBTITLE")}
                </p>
                <div className="mt-6 space-y-3">
                    <Button
                        type="button"
                        onClick={onView}
                        className="w-full"
                    >
                        {t("MY_CONTENT_SUCCESS_VIEW_CONTENT")}
                    </Button>
                    <Button
                        type="button"
                        onClick={onClose}
                        variant="secondary"
                        className="w-full"
                    >
                        {t("MY_CONTENT_SUCCESS_MY_POSTS")}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ContentSuccessModal;
